export default __webpack_public_path__ + "static/media/koffee.4fa6c967.jpg";